"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgAmenityNoContract(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792 307.2V96c0-54.4-44.8-96-96-96H152c-51.2 0-96 41.6-96 96v832c0 51.2 44.8 96 96 96h544c51.2 0 96-44.8 96-96V716.8c99.2-16 176-102.4 176-204.8-3.2-102.4-76.8-188.8-176-204.8zM728 928c0 16-16 32-32 32H152c-16 0-32-16-32-32V96c0-19.2 16-32 32-32h544c16 0 32 12.8 32 32v211.2c-35.2 6.4-70.4 19.2-96 41.6-3.2-16-16-28.8-32-28.8H248c-19.2 0-32 12.8-32 32s12.8 32 32 32h348.8c-22.4 28.8-35.2 60.8-41.6 96H248c-19.2 0-32 12.8-32 32s12.8 32 32 32h307.2C568 633.6 638.4 704 728 716.8V928zm32-256c-89.6 0-160-70.4-160-160s70.4-160 160-160 160 70.4 160 160-73.6 160-160 160zm-275.2 0c0 19.2-12.8 32-32 32h-208c-19.2 0-32-12.8-32-32s12.8-32 32-32h208c19.2 0 32 12.8 32 32zM840 476.8L804.8 512l32 35.2c12.8 12.8 12.8 32 3.2 44.8-12.8 12.8-32 12.8-44.8 0L760 556.8 724.8 592c-12.8 12.8-32 12.8-44.8 0s-12.8-32 0-44.8l35.2-35.2-35.2-35.2c-12.8-12.8-12.8-32 0-44.8s32-12.8 44.8 0l35.2 35.2 35.2-35.2c12.8-12.8 32-12.8 44.8 0s12.8 32 0 44.8z"
  }));
}

var ForwardRef = React.forwardRef(SvgAmenityNoContract);
var _default = ForwardRef;
exports.default = _default;